import {
  TCreateSectorMasterReq,
  TSearchSectorReq,
  TUpdateSectorMasterReq,
} from "@models/sector";
import { TAxiosResponse } from "types";
import { axiosInstance } from "./axiosInstance";
import { DEFAULT_PAGE_SIZE } from "@constants";

const sectorApi = {
  getSector: async (payload: TSearchSectorReq) => {
    const url = "/api/v1/sector/search";
    const page = payload.page ? payload.page : 1;
    const response: TAxiosResponse = await axiosInstance.get(url, {
      params: {
        companyId: payload.companyId,
        sectorId: payload.sectorId,
        page: page,
        pageSize: DEFAULT_PAGE_SIZE,
      },
    });
    return response;
  },

  getDepartmentByCompany: async (payload: any) => {
    const url = "/Department/departments";
    const response: TAxiosResponse = await axiosInstance.get(url, {
      params: {
        companyId: payload.companyId,
      },
    });
    return response;
  },

  deleteSector: async (payload: string) => {
    const url = `/api/v1/sector/${payload}`;
    const response: TAxiosResponse = await axiosInstance.delete(url);
    return response;
  },

  getCompany: async () => {
    const url = "/company/companies";
    const response: TAxiosResponse = await axiosInstance.get(url);
    return response;
  },

  updateSector: async (payload: TUpdateSectorMasterReq) => {
    const url = `/api/v1/sector/${payload.id}`;
    const response: TAxiosResponse = await axiosInstance.put(url, {
      sectorCode: payload.sectorCode,
      sectorName: payload.sectorName,
      isValidationOnly: payload.isValidationOnly,
    });
    return response;
  },

  createSector: async (payload: TCreateSectorMasterReq) => {
    const url = "/api/v1/sector";
    const response: TAxiosResponse = await axiosInstance.post(url, {
      companyId: payload.companyId,
      sectorCode: payload.sectorCode,
      sectorName: payload.sectorName,
      isValidationOnly: payload.isValidationOnly,
    });
    return response;
  },
};

export { sectorApi };
